module.exports = __webpack_public_path__ + "img/section6-img.49c39276.jpg";